import appInfo from 'js/lib/appInfo';
import { isAuthenticatedUser } from 'js/lib/user';

export const ENT_WEBSITE_BUNDLE_NAME = 'ent-website';

export const isEntWebsite = (pathname?: string): boolean => {
  return (
    pathname?.match(/(ent-website|business|government|campus)(\/)?/gi) != null ||
    appInfo.get()?.appName === ENT_WEBSITE_BUNDLE_NAME
  );
};

export const addUtmInfo = (link: string, domain: string, pathname?: string): string => {
  // Individual has no utm, ent website should not have UTM: https://coursera.atlassian.net/browse/ENTING-952
  if (domain === '' || isEntWebsite(pathname)) {
    return link;
  }

  const modifiedLink = new URL(link);
  let utmContent = '';
  const utmCampaign = 'website';
  const utmMedium = 'coursera';
  const utmSource = 'header';
  const loggedIn = isAuthenticatedUser();
  const utmTerm = `b-${loggedIn ? 'in' : 'out'}`;

  switch (domain) {
    case '/government':
      utmContent = 'corp-to-landing-for-government';
      break;
    case '/campus':
      utmContent = 'corp-to-landing-for-campus';
      break;
    case '/business':
    default:
      utmContent = 'corp-to-home-for-enterprise';
      break;
  }

  modifiedLink.searchParams.set('utm_content', utmContent);
  modifiedLink.searchParams.set('utm_campaign', utmCampaign);
  modifiedLink.searchParams.set('utm_medium', utmMedium);
  modifiedLink.searchParams.set('utm_source', utmSource);
  modifiedLink.searchParams.set('utm_term', utmTerm);

  return modifiedLink.toString();
};
